/* unplugin-vue-components disabled */import script from "./schoolArea.vue?vue&type=script&lang=ts&setup=true"
export * from "./schoolArea.vue?vue&type=script&lang=ts&setup=true"

export default script